import React, { useState } from 'react';
import { confirmResetPassword } from 'aws-amplify/auth';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid';
import SharedButton from '@/global/Button/Button';

export default function NewPassword({ setReset, name }) {
  const [errorMessage, setErrorMessage] = useState('');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [rePassword, setRePassword] = useState('');
  const [isPassVisible, setIsPassVisible] = useState(false);
  const [isRpassVisible, setIsRpassVisible] = useState(false);

  const togglePassVisibility = () => setIsPassVisible(!isPassVisible);
  const toggleRpassVisibility = () => setIsRpassVisible(!isRpassVisible);

  const validar = () => {
    if (!code.trim()) {
      setErrorMessage('Verification code is required');
      return false;
    }
    if (!password.trim()) {
      setErrorMessage('Password is required');
      return false;
    }
    if (password !== rePassword) {
      setErrorMessage('Password and their confirmation do not match');
      return false;
    }
    return true;
  };

  const handleSubmit = async evt => {
    evt.preventDefault();
    setErrorMessage('');

    if (!validar()) return;

    try {
      await confirmResetPassword({
        username: name.trim(),
        confirmationCode: code.trim(),
        newPassword: password.trim(),
      });
      setReset(false);
    } catch (error) {
      setErrorMessage(error.message);
    }
  };

  return (
    <div className="login-container mb-5">
      <div className="form-apply w-full max-w-lg rounded-2xl text-center">
        <form onSubmit={handleSubmit} autoComplete="off">
          <h6 className="text-pink font-bold mb-4">Check your email for the confirmation code:</h6>

          <div className="text-left w-full">
            <label className="text-xs font-semibold text-gray-600 ml-2 text-uppercase">
              Confirmation Code:
            </label>
            <div>
              <input
                onChange={e => setCode(e.target.value)}
                type="text"
                placeholder="Enter the confirmation code..."
                autoComplete="off"
                className="form-input"
              />
            </div>
          </div>

          <div className="text-left w-full mt-4">
            <div className="flex justify-between">
              <label className="text-xs font-semibold text-gray-600 ml-2 text-uppercase">Password:</label>
              <button type="button" className="eye-icon" onClick={togglePassVisibility}>
                {isPassVisible ? (
                  <EyeIcon className="w-4 h-4 mb-1" />
                ) : (
                  <EyeSlashIcon className="w-4 h-4 mb-1" />
                )}
              </button>
            </div>
            <div>
              <input
                onChange={e => setPassword(e.target.value)}
                type={isPassVisible ? 'text' : 'password'}
                className="form-input"
                placeholder="Password"
                autoComplete="new-password"
              />
            </div>
          </div>

          <div className="text-left w-full mt-4">
            <div className="flex justify-between">
              <label className="text-xs font-semibold text-gray-600 ml-2 text-uppercase">
                Retype Password:
              </label>
              <button type="button" className="eye-icon" onClick={toggleRpassVisibility}>
                {isPassVisible ? (
                  <EyeIcon className="w-4 h-4 mb-1" />
                ) : (
                  <EyeSlashIcon className="w-4 h-4 mb-1" />
                )}
              </button>
            </div>
            <div>
              <input
                onChange={e => setRePassword(e.target.value)}
                type={isRpassVisible ? 'text' : 'password'}
                className="form-input"
                placeholder="Retype Password"
                autoComplete="new-password"
              />
            </div>
          </div>

          <div className="text-right">
            <a
              className="text-gray-600 hover:text-blue-950 text-xs mr-2"
              href="true"
              onClick={evt => {
                evt.preventDefault();
                setReset(false);
              }}
            >
              Cancel
            </a>
          </div>

          <div className="container-contact100-form-btn mt-4">
            <SharedButton type="submit" variant="primary" className="w-full">
              Send
            </SharedButton>
          </div>

          {errorMessage && <p className="form-error">{errorMessage}</p>}
        </form>
      </div>
    </div>
  );
}
